/* Maison Felzo — « Suivre cette pièce » (cœur) et compteur de personnes qui la suivent. Lecture et écriture dans MFGestion. */
(function () {
  var box = document.getElementById('Follow')
  if (!box) return
  var btn = document.getElementById('FollowBtn'), txt = document.getElementById('FollowTxt')
  var api = box.getAttribute('data-api'), pid = box.getAttribute('data-pid'), cid = box.getAttribute('data-c'), tok = box.getAttribute('data-t')
  var login = box.getAttribute('data-login'), logged = !!(cid && tok), busy = false
  var handle = box.getAttribute('data-h') || '', titre = box.getAttribute('data-ti') || ''
  var eh = box.getAttribute('data-e') || '', et = box.getAttribute('data-et') || ''
  var state = { count: 0, liked: false }
  function linked() { try { return localStorage.getItem('mf_link') === '1' ? eh : '' } catch (e) { return '' } }
  function url(action) { return api + (api.indexOf('?') > -1 ? '&' : '?') + 'action=' + action }
  function label() {
    var n = state.count
    if (state.liked) return n > 1 ? 'Vous suivez cette pièce, avec ' + (n - 1) + ' autre' + (n > 2 ? 's' : '') + ' personne' + (n > 2 ? 's' : '') : 'Vous suivez cette pièce'
    if (n >= 1) return 'Suivie par ' + n + ' personne' + (n > 1 ? 's' : '')
    return 'Suivre cette pièce'
  }
  function paint() {
    btn.setAttribute('aria-pressed', state.liked ? 'true' : 'false')
    box.classList.toggle('is-liked', state.liked)
    box.classList.toggle('has-count', state.count >= 1)
    txt.textContent = label()
  }
  function load() {
    var q = '&pid=' + encodeURIComponent(pid) + (logged ? '&c=' + encodeURIComponent(cid) + '&t=' + encodeURIComponent(tok) : '')
    fetch(url('site_like_state') + q, { cache: 'no-store' }).then(function (r) { return r.json() }).then(function (d) {
      if (d && d.ok) { state.count = d.count || 0; state.liked = !!d.liked; paint() }
    }).catch(function () {})
  }
  btn.addEventListener('click', function () {
    if (!logged) { if (login) window.location.href = login; return }
    if (busy) return
    busy = true
    var was = { count: state.count, liked: state.liked }
    state.liked = !state.liked
    state.count = Math.max(0, state.count + (state.liked ? 1 : -1))
    paint()   // réponse immédiate, corrigée par le serveur ensuite
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop')
    fetch(url('site_like_toggle'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pid: pid, c: cid, t: tok, h: handle, ti: titre, e: linked(), et: et }) })
      .then(function (r) { return r.json() })
      .then(function (d) {
        busy = false
        if (d && d.ok) { state.count = d.count; state.liked = !!d.liked } else { state.count = was.count; state.liked = was.liked }
        paint()
      }).catch(function () { busy = false; state.count = was.count; state.liked = was.liked; paint() })
  })
  paint()
  load()
})()
